module.exports = __webpack_public_path__ + "img/product-preview-49.d129ebc.png";